module.exports = fox._r("fonts/ropasoftpro-regular-webfont.woff", __webpack_public_path__ + "fonts/2AozcSb.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasoftpro-regular-webfont.woff
// module id = 961
// module chunks = 4